import React, { FC, ReactNode } from 'react';
import { SxProps, Theme } from '@mui/system';
import Box from '@mui/material/Box';

type Props = {
  children: ReactNode;
  index: number;
  sx?: SxProps<Theme>;
  value: number;
};

export const TabPanel: FC<Props> = ({ children, index, sx, value }) => {
  return (
    <Box role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} sx={sx}>
      {value === index && children}
    </Box>
  );
};
